module.exports = __webpack_public_path__ + "img/jp-about-us-bg.f028e8b.webp";